import { render, staticRenderFns } from "./event-details.vue?vue&type=template&id=4bb0c18b&scoped=true&"
import script from "./event-details.vue?vue&type=script&lang=js&"
export * from "./event-details.vue?vue&type=script&lang=js&"
import style0 from "./event-details.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./event-details.vue?vue&type=style&index=1&id=4bb0c18b&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4bb0c18b",
  null
  
)

export default component.exports